import { AuthProvider, UserProvider,AdvisorProvider, TopicsProvider, SettingsProvider, RefundProvider } from "./index";

const ProvidersWrapper = ({ children }) => {


  const providers = {
    AuthProvider,
    UserProvider,
    AdvisorProvider,
    TopicsProvider,
    SettingsProvider,
    RefundProvider
  };
  const ProviderComponents = Object.values(providers);

  return (
    <>
      {ProviderComponents.reduceRight(
        (acc, Comp) => (
          <Comp>{acc}</Comp>
        ),
        children
      )}
    </>
  );
};

export default ProvidersWrapper;
